(() => {
  console.log("[PLZ POPUP] loaded");

  const MODAL_ID = "knittel-plz-gate-modal";
  const STORAGE_PREFIX = "knittel_plz_ok_";

  let bypassOnce = false;
  let pending = null; // { form, submitter }

  function ensureModal() {
    let modal = document.getElementById(MODAL_ID);
    if (modal) return modal;

    modal = document.createElement("div");
    modal.id = MODAL_ID;
    modal.hidden = true;
    modal.setAttribute("role", "dialog");
    modal.setAttribute("aria-modal", "true");

    modal.innerHTML = `
      <div class="knittel-plz-modal">
        <div class="knittel-plz-modal__backdrop" data-close></div>

        <div class="knittel-plz-modal__card" role="document" aria-labelledby="knittel-plz-title">
          <button class="knittel-plz-modal__close" type="button" data-close aria-label="Schließen">×</button>

          <div class="knittel-plz-modal__content">
            <div class="knittel-plz-modal__title" id="knittel-plz-title">
              VERFÜGBARKEIT FÜR IHR EINZUGSGEBIET PRÜFEN
            </div>

            <div class="knittel-plz-box">
              <div class="knittel-plz-row">
                <input
                  class="knittel-plz-input"
                  id="knittel-plz-input"
                  type="text"
                  inputmode="numeric"
                  autocomplete="postal-code"
                  maxlength="5"
                  placeholder="z.B. 89287"
                />
                <button type="button" class="knittel-plz-check" id="knittel-plz-check">Prüfen</button>
              </div>

              <div class="knittel-plz-msg" id="knittel-plz-msg">
                Bitte PLZ eingeben und auf „Prüfen“ klicken.
              </div>
            </div>

            <div class="knittel-plz-actions">
              <button id="knittel-plz-continue" type="button" class="knittel-plz-continue" disabled>Weiter</button>
            </div>
          </div>
        </div>
      </div>
    `;

    const style = document.createElement("style");
    style.textContent = `
      /* Overlay */
      .knittel-plz-modal{
        position:fixed; inset:0; z-index:100000;
        display:flex; align-items:center; justify-content:center;
        padding:24px;
      }
      .knittel-plz-modal__backdrop{ position:absolute; inset:0; background:rgba(0,0,0,.45); }

      /* Card */
      .knittel-plz-modal__card{
        position:relative; z-index:1;
        width:min(920px, 100%);
        background:#fff; border-radius:18px;
        box-shadow:0 16px 40px rgba(0,0,0,.22);
        overflow:hidden;
      }

      .knittel-plz-modal__close{
        position:absolute; top:14px; right:16px;
        width:44px; height:44px;
        border:0; background:transparent;
        font-size:30px; line-height:1; cursor:pointer;
      }

      .knittel-plz-modal__content{ padding:26px 26px 22px 26px; }

      .knittel-plz-modal__title{
        font-size:24px; font-weight:800; text-transform:uppercase;
        line-height:1.2; text-align:center;
        margin:0 0 18px 0; color:rgba(0,0,0,.88);
        letter-spacing:.4px;
      }

      .knittel-plz-box{
        border:1px solid rgba(0,0,0,.12);
        border-radius:16px;
        padding:20px;
        background:#fff;
      }

      .knittel-plz-row{
        display:flex; gap:12px;
        align-items:center; justify-content:center;
      }

      .knittel-plz-input{
        flex:1; max-width:520px;
        height:50px; padding:0 14px;
        border:1px solid rgba(0,0,0,.22);
        border-radius:12px;
        font-size:14px;
        outline:none;
      }

      .knittel-plz-check{
        height:50px; padding:0 18px;
        border:2px solid rgb(245,130,33);
        border-radius:12px; cursor:pointer;
        font-size:14px;
        background:rgb(245,130,33); color:#fff;
        font-weight:700; white-space:nowrap;
      }

      .knittel-plz-msg{
        margin-top:14px;
        font-weight:400;
        font-size:14px;
        line-height:1.35;
        text-align:center;
        color:rgba(0,0,0,.70);
      }

      .knittel-plz-actions{
        margin-top:18px;
        display:flex;
        justify-content:flex-end;
      }

      .knittel-plz-continue{
        height:50px;
        padding:0 18px;
        width:200px;
        border-radius:14px;
        border:1px solid transparent;
        background:#111; color:#fff;
        font-weight:800; font-size:14px;
        cursor:pointer;
      }
      .knittel-plz-continue[disabled]{ opacity:.45; cursor:not-allowed; }

   @media (max-width: 749px){
  .knittel-plz-modal{ padding: 12px; }

  .knittel-plz-modal__card{
    max-width: 520px;
    width: 100%;
    border-radius: 18px;
  }

  .knittel-plz-modal__content{
    padding: 16px 14px 14px;
  }

  .knittel-plz-modal__close{
    top: 8px;
    right: 8px;
    width: 42px;
    height: 42px;
    font-size: 30px;
    line-height: 1;
  }

  .knittel-plz-modal__title{
    font-size: 18px;
    line-height: 1.2;
    margin: 2px 34px 12px 6px; /* Platz für X rechts */
    text-align: left;
    letter-spacing: .2px;
  }

  .knittel-plz-box{
    padding: 14px;
    border-radius: 14px;
  }

  .knittel-plz-row{
    display: grid;
    grid-template-columns: 1fr;
    gap: 10px;
    justify-content: stretch;
  }

  .knittel-plz-input{
    max-width: none;
    width: 100%;
    height: 46px;
    border-radius: 12px;
    font-size: 16px; /* verhindert iOS Zoom */
    text-align: left;
    padding: 0 14px;
  }

  .knittel-plz-check{
    width: 100%;
    height: 46px;
    border-radius: 12px;
    font-size: 14px;
    font-weight: 700;
  }

  .knittel-plz-msg{
    margin-top: 10px;
    font-size: 13px;
    line-height: 1.35;
  }

  .knittel-plz-actions{
    margin-top: 12px;
    justify-content: stretch;
  }

  .knittel-plz-continue{
    width: 100%;
    height: 46px;
    border-radius: 12px;
    font-size: 14px;
  }
}

    `;
    document.head.appendChild(style);
    document.body.appendChild(modal);

    return modal;
  }

  function openModal(modal) {
    modal.hidden = false;
    document.documentElement.style.overflow = "hidden";
  }

  function closeModal(modal) {
    modal.hidden = true;
    document.documentElement.style.overflow = "";
  }

  function validPLZ(v) {
    return /^[0-9]{5}$/.test(String(v || "").trim());
  }

  function isAddToCartForm(form) {
    if (!form) return false;
    const dt = form.getAttribute("data-type");
    const action = form.getAttribute("action") || "";
    return dt === "add-to-cart-form" || action.includes("/cart/add");
  }

  function getWhitelist(form) {
    const raw = form?.dataset?.zipWhitelist || "";
    return String(raw).split(",").map(s => s.trim()).filter(Boolean);
  }

  function requiresSellingPlan(form) {
    const v = String(form?.dataset?.requiresSellingPlan || "").toLowerCase();
    return v === "true" || v === "1";
  }

  function getStorageKey(form) {
    const handle = form?.dataset?.productHandle || "";
    const pid = form?.dataset?.productId || "";
    return STORAGE_PREFIX + (handle || pid || "unknown");
  }

  function isStoredOk(key) {
    try {
      const raw = localStorage.getItem(key);
      if (!raw) return false;
      const data = JSON.parse(raw);
      return !!(data && data.ok);
    } catch {
      return false;
    }
  }

  function storeOk(key, plz) {
    localStorage.setItem(key, JSON.stringify({ ok: true, plz, ts: Date.now() }));
  }

  function getSubmitterFromEvent(e) {
    if (e && e.submitter) return e.submitter;
    const path = typeof e.composedPath === "function" ? e.composedPath() : [];
    const btn = path.find(n => n && n.tagName === "BUTTON");
    return btn || null;
  }

  function openGate(form, submitter) {
    const modal = ensureModal();
    const input = modal.querySelector("#knittel-plz-input");
    const checkBtn = modal.querySelector("#knittel-plz-check");
    const msg = modal.querySelector("#knittel-plz-msg");
    const cont = modal.querySelector("#knittel-plz-continue");

    pending = { form, submitter };

    cont.disabled = true;
    msg.textContent = "Bitte PLZ eingeben und auf „Prüfen“ klicken.";
    msg.style.color = "rgba(0,0,0,.70)";
    input.value = "";

    openModal(modal);
    setTimeout(() => input.focus(), 50);

    modal.querySelectorAll("[data-close]").forEach(el => (el.onclick = () => closeModal(modal)));
    document.onkeydown = (ev) => { if (!modal.hidden && ev.key === "Escape") closeModal(modal); };

    const storageKey = getStorageKey(form);

    checkBtn.onclick = () => {
      const plz = String(input.value || "").trim();

      if (!validPLZ(plz)) {
        msg.textContent = "Bitte eine 5-stellige PLZ eingeben.";
        msg.style.color = "rgba(190,0,0,.9)";
        cont.disabled = true;
        return;
      }

      const whitelist = getWhitelist(form);
      if (!whitelist.length) {
        msg.textContent = "Dieses Produkt hat keine PLZ-Liste hinterlegt.";
        msg.style.color = "rgba(190,0,0,.9)";
        cont.disabled = true;
        return;
      }

      const ok = whitelist.includes(plz);

      if (ok) {
        msg.textContent = "✅ Dieses Produkt ist in Ihrer PLZ lieferbar.";
        msg.style.color = "#1f7a1f";
        storeOk(storageKey, plz);
        cont.disabled = false;
      } else {
        msg.textContent = "❌ Dieses Produkt ist in Ihrer PLZ nicht lieferbar.";
        msg.style.color = "rgba(190,0,0,.9)";
        cont.disabled = true;
      }
    };

    input.onkeydown = (ev) => {
      if (ev.key === "Enter") { ev.preventDefault(); checkBtn.click(); }
    };

    cont.onclick = () => {
      if (!isStoredOk(storageKey)) return;

      closeModal(modal);

      const p = pending;
      pending = null;

      bypassOnce = true;

      // ✅ Jetzt darf das Produkt normal adden
      if (p?.form?.requestSubmit) {
        if (p.submitter) p.form.requestSubmit(p.submitter);
        else p.form.requestSubmit();
      } else if (p?.form) {
        p.form.submit();
      }
    };
  }

  // SUBMIT Capture: Hauptweg
  document.addEventListener("submit", (e) => {
    if (bypassOnce) { bypassOnce = false; return; }

    const form = e.target;
    if (!(form instanceof HTMLFormElement)) return;
    if (!isAddToCartForm(form)) return;

    // ✅ Abo-Produkte NIE blocken
    if (requiresSellingPlan(form)) return;

    // ✅ Nur blocken, wenn Whitelist vorhanden ist
    const whitelist = getWhitelist(form);
    if (!whitelist.length) return;

    const storageKey = getStorageKey(form);
    if (isStoredOk(storageKey)) return;

    e.preventDefault();
    e.stopPropagation();

    const submitter = getSubmitterFromEvent(e);
    openGate(form, submitter);
  }, true);

  // CLICK Capture: für Custom-Button-Flows
  document.addEventListener("click", (e) => {
    if (bypassOnce) { bypassOnce = false; return; }

    const path = typeof e.composedPath === "function" ? e.composedPath() : [];
    const btn = path.find(n => n && n.tagName === "BUTTON");
    if (!btn) return;

    const form = btn.closest("form");
    if (!form || !isAddToCartForm(form)) return;

    // ✅ Abo-Produkte NIE blocken
    if (requiresSellingPlan(form)) return;

    // ✅ Nur blocken, wenn Whitelist vorhanden ist
    const whitelist = getWhitelist(form);
    if (!whitelist.length) return;

    const storageKey = getStorageKey(form);
    if (isStoredOk(storageKey)) return;

    // nur echte Kaufbuttons
    const isBuyBtn =
      btn.name === "add" ||
      btn.classList?.contains("add-to-cart-button") ||
      btn.closest?.(".shopify-payment-button");

    if (!isBuyBtn) return;

    e.preventDefault();
    e.stopPropagation();

    openGate(form, btn);
  }, true);
})();
